export const PHONE_NEEDED_FOR_SOME_CARRIERS = 'phoneNeededForSomeCarriers';
export const MULTI_LINE_EMAIL_SUB_LABEL = 'multiLineEmailSubLabel';
